import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import HouseholdSectionBillingContainer from './HouseholdSectionBilling/HouseholdSectionBillingContainer';


const HouseholdSectionBillingPicker = ({ householdResource }) => {
  return pick(householdResource, {
    [fr.relationships.householdSectionBilling.name]: (<HouseholdSectionBillingContainer relationshipLink={householdResource?.relationship(fr.relationships.householdSectionBilling.name)?.link('related')} />),
  }, null);
};

HouseholdSectionBillingPicker.propTypes = {
  householdResource: PropTypes.instanceOf(fr.Resource).isRequired,
};
HouseholdSectionBillingPicker.defaultProps = {};

export default HouseholdSectionBillingPicker;
